import React, { useState } from "react";
import { Button } from "./ui/button";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { exportListToExcel } from "../lib/tableExport";

/**
 * @param {object} props
 * @param {string} props.apiPath
 * @param {Record<string, string>} props.params
 * @param {import('../lib/dataTable').DataTableColumn[]} props.columns
 * @param {string} props.filename
 */
export default function DataTableExportButton({
  apiPath,
  params,
  columns,
  filename,
  testId = "data-table-export",
}) {
  const [busy, setBusy] = useState(false);

  const handleExport = async () => {
    setBusy(true);
    try {
      await exportListToExcel({
        api,
        path: apiPath,
        params,
        columns,
        filename,
        onError: (msg) => toast.error(msg),
      });
      toast.success("Excel downloaded");
    } catch {
      /* toast shown in helper */
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="h-8 text-xs gap-1"
      disabled={busy}
      onClick={handleExport}
      data-testid={testId}
    >
      <Download className="h-3.5 w-3.5" />
      {busy ? "Exporting…" : "Export Excel"}
    </Button>
  );
}
